import type { Components, Theme } from "@mui/material";

export const MuiCircularProgress: Components<Theme>["MuiCircularProgress"] = {
  defaultProps: {
    color: "pink",
    size: 30
  }
};
